"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const transformToken = (name, token) => [
    {
        name,
        tokenType: "fontFamily",
        type: "variable",
        value: `${token.family}`,
    },
];
exports.default = transformToken;
